import React, { useState } from "react";
import {
  Box,
  Paper,
  Tabs,
  Tab,
  Typography,
} from "@mui/material";

import LegalClientsDashboard from "./LegalClientsdashboard";
import LegalVendorsDashboard from "./LegalVendorsdashboard";

const ResourceManagement = () => {
  const [tab, setTab] = useState(0); // 0 = Clients (default)

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" fontWeight={700} mb={3}>
        Client & Vendor Resource Management
      </Typography>

      <Paper
        elevation={2}
        sx={{
          borderRadius: 3,
          overflow: "hidden",
        }}
      >
        <Tabs
          value={tab}
          onChange={(e, newValue) => setTab(newValue)}
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            bgcolor: "background.paper",

            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: 600,
              fontSize: "1rem",
            },
          }}
        >
          <Tab label="Clients" />
          <Tab label="Vendors" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {tab === 0 && <LegalClientsDashboard />}
          {tab === 1 && <LegalVendorsDashboard />}
        </Box>
      </Paper>
    </Box>
  );
};

export default ResourceManagement;